import React, { useState, useEffect } from "react";
import API_DOMAIN from "../config/config";
import {
  Container,
  Row,
  Col,
  Table,
  Button,
  Modal,
  Tab,
  Tabs,
} from "react-bootstrap";
import {
  Calender,
  TextInputForm,
  DropDownUI,
  DropDownUItest,
} from "../components/Forms";
import { PageHead } from "../components/PageTitle";
import { MdOutlineDeleteOutline } from "react-icons/md";
import { useNavigate, Navigate } from "react-router-dom";
import {
  Buttons,
  Dltbtn,
  InstantCreate,
  ClickButton,
  Delete,
} from "../components/Buttons";
import PayMents from "../components/PayMents";
import { BiPlus } from "react-icons/bi";
import { useLocation } from "react-router-dom";
import { ValueContainer } from "react-select/animated";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { MdDeleteForever } from "react-icons/md";
import moment from "moment/moment";
const DOMAIN = "https://viswacrackers.zentexus.in/api";

// saleinvoice start
const SalesInvoiceEntry = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { type, rowData } = location.state || {};
  const [showModal, setShowModal] = useState(false);
  const [toggled, setToggled] = useState(false);
  const [tax_type, settax_type] = useState("");
  const [loading, setLoading] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [productData, setProductData] = useState([]);
  const [UnitData, setUnitData] = useState([]);
  const [discountType, setDiscountType] = useState(
    rowData?.discount_type || "Discount %"
  );

  const handleClick = () => {
    setToggled(!toggled);
  };

  const initialState =
    type === "edit"
      ? {
          ...rowData,
          discount:
            rowData.discount !== undefined ? rowData.discount.toString() : "0",
          discount_type: rowData.discount_type || "Discount %",
          subtotal: rowData.sub_total || "0",
          balance_amount: rowData.balance || "0",
          total: (
            parseFloat(rowData.sub_total || 0) -
            (rowData.discount_type === "Discount Amount"
              ? parseFloat(rowData.discount || 0)
              : (parseFloat(rowData.sub_total || 0) *
                  parseFloat(rowData.discount || 0)) /
                100)
          ).toFixed(2),
          total_net_rate: rowData.total_net_rate || "0",
          total_discount_rate: rowData.total_discount_rate || "0",
          product: rowData.product || [],
          payment_method: Array.isArray(rowData.payment_method)
            ? rowData.payment_method
            : typeof rowData.payment_method === "string"
            ? JSON.parse(rowData.payment_method || "[]")
            : [],
          bill_date:
            rowData.bill_date && moment(rowData.bill_date).isValid()
              ? moment(rowData.bill_date).format("YYYY-MM-DD")
              : moment().format("YYYY-MM-DD"),
        }
      : {
          party_name: "",
          eway_no: "",
          vechile_no: "",
          bill_date: moment().format("YYYY-MM-DD"),
          state_of_supply: "",
          mobile_number: "",
          address: "",
          total: "",
          subtotal: "",
          paid: "",
          balance_amount: "",
          final_total: "",
          discount: "",
          discount_type: "Discount %",
          total_discountall: "",
          taxover_amt: "",
          taxover_percentage: "",
          round_off_checkbox: "",
          remark: "",
          total_net_rate: "0",
          total_discount_rate: "0",
          payment_method: [],
          product: [
            {
              product_id: "",
              qty: "",
              unit: "",
              price_unit: "",
              discount_rate: "",
              discount_percentage: "",
              discount_amt: "",
              tax_type: "",
              tax_percentage: "",
              tax_amt: "",
              CGST: "",
              SGST: "",
              IGST: "",
              total_amt: "",
              total_net_amount: "",
              total_discount_amount: "",
            },
          ],
        };

  useEffect(() => {
    if (type === "edit" && rowData?.payment_method) {
      try {
        const parsedPayments = Array.isArray(rowData.payment_method)
          ? rowData.payment_method
          : JSON.parse(rowData.payment_method || "[]");
        setPaymentDetails(parsedPayments || []);
      } catch (error) {
        console.error("Error parsing payment_method:", error);
        setPaymentDetails([]);
      }
    }

    setDiscountType(formData.discount_type || "Discount %");
  }, [type, rowData]);

  const [formData, setFormData] = useState(initialState);
  console.log(formData);
  const [formDataPartySales, setformDataPartySales] = useState({
    party_name: "",
    mobile_number: "",
    alter_number: "",
    email: "",
    company_name: "",
    gst_no: "",
    address: "",
    opening_balance: "",
    opening_date: "",
    ac_type: "",
  });
  const setLabel = (value, field) => {
    if (!value || !moment(value).isValid()) {
      console.error("Invalid date received in setLabel:", value);
      return;
    }
    setFormData({
      ...formData,
      [field]: moment(value).format("YYYY-MM-DD"),
    });
  };

  const setLabell = (value, field) => {
    setformDataPartySales({
      ...formDataPartySales,
      [field]: moment(value).format("YYYY-MM-DD"),
    });
  };
  const [paymentDetails, setPaymentDetails] = React.useState([]);

  const [newPayment, setNewPayment] = React.useState({
    payment_method: "",
    amount: "",
    balance: "",
  });

  const handleAddPayment = () => {
    const totalPaymentAmount = paymentDetails.reduce(
      (total, payment) => total + (parseFloat(payment.amount) || 0),
      0
    );
    const balance = parseFloat(formData.total) || 0;

    if (newPayment.payment_method && newPayment.amount) {
      if (totalPaymentAmount + parseFloat(newPayment.amount) > balance) {
        alert(
          "Insufficient balance. The total payment amount exceeds the available balance."
        );
      } else {
        const updatedPayment = {
          ...newPayment,
          balance: (
            balance -
            (totalPaymentAmount + parseFloat(newPayment.amount))
          ).toFixed(2),
        };
        setPaymentDetails((prev) => [...prev, updatedPayment]);
        setNewPayment({ payment_method: "", amount: "", balance: "" });
      }
    } else {
      alert("Please select a payment method and enter an amount.");
    }
  };

  const fetchProductData = async () => {
    try {
      const companyId = localStorage.getItem("companyId");
      const response = await fetch(`${DOMAIN}/products.php?id=${companyId}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          search_text: "",
        }),
      });

      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }

      const responseData = await response.json();
      console.log("fetchProductData", responseData);
      setLoading(false);

      if (responseData.status === 200 && Array.isArray(responseData.data)) {
        const validData = responseData.data.filter(
          (item) => item && typeof item.product_name === "string"
        );
        setProductData(validData);
      } else {
        throw new Error(responseData.msg);
      }
    } catch (error) {
      setLoading(false);
      console.error("Error fetching data:", error.message);
    }
  };
  const fetchUnitData = async () => {
    try {
      const companyId = localStorage.getItem("companyId");
      const response = await fetch(`${API_DOMAIN}/unit.php?id=${companyId}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          search_text: "",
        }),
      });
      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }

      const responseData = await response.json();

      if (responseData.status === 200) {
        setUnitData(responseData.data);
      } else {
        throw new Error(responseData.msg);
      }
    } catch (error) {
      console.error("Error fetching data:", error.message);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUnitData();
    fetchProductData();
  }, []);

  const errorAlert = (input) => {
    toast.error(input, {
      position: "top-center",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
    });
  };
  const successAlert = (success) => {
    toast.success(success, {
      position: "top-center",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
    });
  };

  const handleSubmit = async () => {
    try {
      const sanitizedFormData = {
        ...formData,
        payment_method: paymentDetails,
        discount_type: discountType,
        product: formData.product.map((product) => ({
          ...product,
          tax_amt: product.tax_amt || "0",
          tax_percentage: product.tax_percentage || "0",
          CGST: product.CGST || "0",
          SGST: product.SGST || "0",
          IGST: product.IGST || "0",
          total_net_amount: product.total_net_amount || "0",
          total_discount_amount: product.total_discount_amount || "0",
          without_tax_amount: (
            (parseFloat(product.qty) || 0) *
              (parseFloat(product.discount_rate) || 0) -
            (parseFloat(product.discount_amt) || 0)
          ).toFixed(2),
        })),
        sub_total: formData.subtotal,
        discount: formData.discount,
        balance: formData.balance_amount,
        total_net_rate: formData.total_net_rate,
        total_discount_rate: formData.total_discount_rate,
        sum_total: formData.product
          .reduce(
            (acc, row) =>
              acc +
              ((parseFloat(row.qty) || 0) *
                (parseFloat(row.discount_rate) || 0) -
                (parseFloat(row.discount_amt) || 0)),
            0
          )
          .toFixed(2),
      };

      const companyId = localStorage.getItem("companyId");

      const response = await fetch(
        `${API_DOMAIN}/salesinvoice.php?id=${companyId}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(sanitizedFormData),
        }
      );
      console.log(JSON.stringify(sanitizedFormData));

      const responseData = await response.json();
      console.log(responseData);

      if (responseData.status === 200) {
        setFormData(initialState);
        setPaymentDetails([]);
        successAlert(responseData.msg);
        setTimeout(() => {
          navigate("/console/sales/invoice");
        }, 2000);
      } else {
        handleErrors(responseData);
      }
    } catch (error) {
      console.error("Error during submission:", error.message);
      errorAlert(error.message);
    }
  };

  const handleErrors = (responseData) => {
    if (responseData.status === 400) {
      toast.error(responseData.msg, {
        position: "top-center",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    } else {
      setShowAlert(true);
    }
  };

  const handleUpdateSubmit = async () => {
    try {
      setLoading(true);
      const companyId = localStorage.getItem("companyId");

      const sum_total = formData.product
        .reduce(
          (acc, row) =>
            acc +
            ((parseFloat(row.qty) || 0) * (parseFloat(row.discount_rate) || 0) -
              (parseFloat(row.discount_amt) || 0)),
          0
        )
        .toFixed(2);

      const subtotal = parseFloat(formData.subtotal) || 0;
      const discount = parseFloat(formData.discount) || 0;
      const total =
        discountType === "Discount %"
          ? (subtotal - (subtotal * discount) / 100).toFixed(2)
          : (subtotal - discount).toFixed(2);

      const paid = paymentDetails
        .reduce((acc, pm) => acc + (parseFloat(pm.amount) || 0), 0)
        .toFixed(2);

      const balance = (parseFloat(total) - parseFloat(paid)).toFixed(2);

      const requestBody = {
        ...formData,
        payment_method: paymentDetails,
        discount_type: discountType,
        product: formData.product.map((product) => ({
          ...product,
          tax_amt: product.tax_amt || "0",
          tax_percentage: product.tax_percentage || "0",
          CGST: product.CGST || "0",
          SGST: product.SGST || "0",
          IGST: product.IGST || "0",
          total_net_amount: product.total_net_amount || "0",
          total_discount_amount: product.total_discount_amount || "0",
          without_tax_amount: (
            (parseFloat(product.qty) || 0) *
              (parseFloat(product.discount_rate) || 0) -
            (parseFloat(product.discount_amt) || 0)
          ).toFixed(2),
        })),
        invoice_id: rowData.invoice_id,
        sub_total: formData.subtotal,
        discount: formData.discount,
        total: total,
        sum_total: sum_total,
        paid: paid,
        balance: balance,
        total_net_rate: formData.total_net_rate,
        total_discount_rate: formData.total_discount_rate,
      };

      console.log("Sending requestBody to backend:", requestBody);

      const response = await fetch(
        `${API_DOMAIN}/salesinvoice.php?id=${companyId}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestBody),
        }
      );

      const responseData = await response.json();
      console.log("Backend response:", responseData);

      if (responseData.status === 200) {
        toast.success("Sales Invoice updated successfully!", {
          position: "top-center",
          autoClose: 2000,
          theme: "colored",
        });
        setTimeout(() => {
          navigate("/console/sales/invoice");
        }, 2000);
      } else {
        toast.error(responseData.msg || "Failed to update invoice", {
          position: "top-center",
          autoClose: 2000,
          theme: "colored",
        });
      }
    } catch (error) {
      console.error("Error updating invoice:", error.message);
      toast.error("Error updating invoice: " + error.message, {
        position: "top-center",
        autoClose: 2000,
        theme: "colored",
      });
    } finally {
      setLoading(false);
    }
  };
  const handleAddRow = () => {
    setFormData((prevState) => ({
      ...prevState,
      product: [...prevState.product, {}],
    }));
  };

  const handleDeleteRow = (index) => {
    setFormData((prevState) => ({
      ...prevState,
      product: prevState.product.filter((_, i) => i !== index),
    }));
  };

  const handleChangePartySales = (e, fieldName) => {
    const value = e.target ? e.target.value : e.value;

    setformDataPartySales({
      ...formDataPartySales,
      [fieldName]: value,
    });
  };

  const handlePaidChange = (e) => {
    const value = parseFloat(e.target.value) || 0;

    setFormData((prevFormData) => ({
      ...prevFormData,
      paid: value,
    }));
  };

  const calculateTotal = (product) => {
    const totalAmount = product.reduce(
      (acc, row) => acc + (parseFloat(row.total_amt) || 0),
      0
    );
    const discountValue = parseFloat(formData.discount) || 0;
    const newTotal =
      discountType === "Discount %"
        ? (totalAmount - (totalAmount * discountValue) / 100).toFixed(2)
        : (totalAmount - discountValue).toFixed(2);

    const totalNetRate = product.reduce(
      (acc, row) =>
        acc + (parseFloat(row.qty) || 0) * (parseFloat(row.price_unit) || 0),
      0
    );

    const totalDiscountRate = product.reduce(
      (acc, row) =>
        acc + (parseFloat(row.qty) || 0) * (parseFloat(row.discount_rate) || 0),
      0
    );

    setFormData((prevData) => ({
      ...prevData,
      subtotal: totalAmount.toFixed(2),
      total: newTotal,
      total_net_rate: totalNetRate.toFixed(2),
      total_discount_rate: totalDiscountRate.toFixed(2),
    }));
  };

  const handleDiscountChange = (e) => {
    const { value } = e.target;
    const discountValue = parseFloat(value) || 0;
    const subtotalValue = parseFloat(formData.subtotal) || 0;

    const newTotal =
      discountType === "Discount %"
        ? (subtotalValue - (subtotalValue * discountValue) / 100).toFixed(2)
        : (subtotalValue - discountValue).toFixed(2);

    setFormData((prevData) => ({
      ...prevData,
      discount: value,
      total: newTotal,
    }));
  };

  const handleKeyPress = (event, index) => {
    if (event.key === "Enter") {
      const lastRow = formData.product[formData.product.length - 1];
      if (
        lastRow.product_id &&
        lastRow.qty &&
        lastRow.unit &&
        lastRow.price_unit &&
        lastRow.discount_rate &&
        lastRow.total_amt &&
        lastRow.total_net_amount &&
        lastRow.total_discount_amount
      ) {
        handleAddRow();
      } else {
        toast.error(
          "Please fill in all fields in the last row before adding a new row"
        );
      }
    }
  };

  const handleRemarkChange = (e) => {
    const { name, value } = e.target;

    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleChange = (e, fieldName, rowIndex) => {
    const value = e.target ? e.target.value : e.value;
    let updatedFormData = { ...formData };

    if (rowIndex !== undefined) {
      updatedFormData = {
        ...formData,
        product: formData.product.map((row, index) =>
          index === rowIndex ? { ...row, [fieldName]: value } : row
        ),
      };
    } else {
      updatedFormData = {
        ...formData,
        [fieldName]: value,
      };
    }

    updatedFormData.product.forEach((row, index) => {
      const qty = parseFloat(row.qty) || 0;
      const priceUnit = parseFloat(row.price_unit) || 0;
      const discountRate = parseFloat(row.discount_rate) || 0;
      const discountPercentage = parseFloat(row.discount_percentage) || 0;
      const discountInputAmount = parseFloat(row.discount_amt) || 0;
      const taxPercentage = parseFloat(row.tax_percentage) || 0;
      const taxType = row.tax_type;

      let sgst = 0,
        cgst = 0,
        igst = 0;

      let crtdiscountFiled = 0.0;

      let subtotal = qty * priceUnit;

      if (fieldName === "discount_rate" && index === rowIndex) {
        crtdiscountFiled = isNaN(discountPercentage)
          ? 0
          : (subtotal * discountPercentage) / 100;
        updatedFormData.product[index].discount_amt =
          crtdiscountFiled.toFixed(2);
      }
      if (fieldName === "discount_percentage" && index === rowIndex) {
        crtdiscountFiled = isNaN(discountPercentage)
          ? 0
          : (subtotal * discountPercentage) / 100;
        updatedFormData.product[index].discount_amt =
          crtdiscountFiled.toFixed(2);
      } else if (fieldName === "discount_amt" && index === rowIndex) {
        crtdiscountFiled = isNaN(discountInputAmount) ? 0 : discountInputAmount;
        const cal = (crtdiscountFiled / subtotal) * 100;
        updatedFormData.product[index].discount_percentage = isNaN(cal)
          ? 0
          : parseFloat(cal).toFixed(2);
      }

      let tmpsubtotal =
        subtotal - (isNaN(crtdiscountFiled) ? 0 : crtdiscountFiled);

      let taxAmount =
        isNaN(tmpsubtotal) || isNaN(taxPercentage)
          ? 0
          : (tmpsubtotal * taxPercentage) / 100;

      let finalAmount = tmpsubtotal + taxAmount;

      if (taxType === "IGST") {
        igst = taxAmount;
      } else {
        let gstamount = taxAmount / 2;
        cgst = gstamount;
        sgst = gstamount;
      }

      updatedFormData.product[index].SGST = sgst.toFixed(2);
      updatedFormData.product[index].CGST = cgst.toFixed(2);
      updatedFormData.product[index].IGST = igst.toFixed(2);
      updatedFormData.product[index].tax_amt = taxAmount.toFixed(2);
      updatedFormData.product[index].total_amt = finalAmount.toFixed(2);
      updatedFormData.product[index].total_net_amount = (
        qty * priceUnit
      ).toFixed(2);
      updatedFormData.product[index].total_discount_amount = (
        qty * discountRate
      ).toFixed(2);
    });

    const totalAmount = updatedFormData.product.reduce(
      (acc, row) => acc + parseFloat(row.total_amt || 0),
      0
    );
    updatedFormData.total = totalAmount.toFixed(2);

    setFormData(updatedFormData);
  };

  useEffect(() => {
    calculateTotal(formData.product);
  }, [formData.product, discountType, formData.discount]);

  useEffect(() => {
    const updateBalance = () => {
      const total = parseFloat(formData.total) || 0;
      const paidAmount = paymentDetails.reduce(
        (acc, pm) => acc + (parseFloat(pm.amount) || 0),
        0
      );
      const balance = total - paidAmount;

      setFormData((prevFormData) => ({
        ...prevFormData,
        balance_amount: balance.toFixed(2),
        paid: paidAmount.toFixed(2),
      }));
    };

    updateBalance();
  }, [formData.total, paymentDetails]);

  function calculateTax(product, tax_percentage, index, taxType) {
    let updatedFormData = { ...formData };
    let sgst = 0,
      cgst = 0,
      igst = 0;

    const productTotal = parseFloat(product.total_amt) || 0;
    const taxRate = parseFloat(tax_percentage.match(/\d+\.*\d*/)?.[0]) || 0;
    const taxAmount = productTotal - productTotal / (1 + taxRate / 100);

    console.log("tax_percentage", tax_percentage);

    if (taxType === "GST") {
      const gstAmount = taxAmount / 2;
      sgst = gstAmount;
      cgst = gstAmount;
    } else if (taxType === "IGST") {
      igst = taxAmount;
    }

    updatedFormData.product[index].SGST = sgst.toFixed(2);
    updatedFormData.product[index].CGST = cgst.toFixed(2);
    updatedFormData.product[index].IGST = igst.toFixed(2);
    updatedFormData.product[index].tax_amt = taxAmount.toFixed(2);
    updatedFormData.product[index].tax_type = taxType;

    setFormData(updatedFormData);
  }

  const defaultDate =
    type === "edit" ? formData.bill_date : new Date().toISOString();

  const [isLoggedIn, setIsLoggedIn] = useState(true);
  useEffect(() => {
    const checkSession = async () => {
      try {
        const session = localStorage.getItem("session");
        if (!session) {
          setIsLoggedIn(false);
        }
      } catch (error) {
        console.error("Error checking session:", error.message);
        setIsLoggedIn(false);
      }
    };
    checkSession();
  }, []);
  if (!isLoggedIn) {
    return <Navigate to="/login" replace />;
  }

  const discountOptions = [
    { value: "Discount %", label: "Discount %" },
    { value: "Discount Amount", label: "Discount Amount" },
  ];

  return (
    <>
      <div className="main" style={{ cursor: "pointer" }}>
        <Container fluid className="px-0">
          <Row>
            <Col lg="12" className="py-3">
              <PageHead
                pagehead={<>Sales Invoice</>}
                onClick={() => navigate(-1)}
              />
            </Col>
            <Col lg="12" className="py-3">
              <Table>
                <tr>
                  <td>
                    <div className="party-on">
                      <Container>
                        <Row>
                          <Col lg="4" className="py-3">
                            <div className="d-flex">
                              <div className="w-250">
                                <TextInputForm
                                  placeholder={"Party Name"}
                                  labelname={"Party Name"}
                                  name="Party Name"
                                  required={"*"}
                                  value={formData.party_name}
                                  onChange={(e) =>
                                    handleChange(e, "party_name")
                                  }
                                />
                              </div>
                            </div>
                          </Col>
                          <Col lg="4" className="py-3">
                            <div className="W-50">
                              <TextInputForm
                                placeholder={"Mobile Number"}
                                labelname={"Mobile Number"}
                                required={"*"}
                                name="mobile_number"
                                value={formData.mobile_number}
                                onChange={(e) =>
                                  handleChange(e, "mobile_number")
                                }
                              />
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col lg="4" className="py-3">
                            <label className="pb-2">
                              <span className="text-danger">*</span>Address
                            </label>
                            <textarea
                              className="form-cntrl form-control"
                              placeholder={"Address"}
                              labelname={"Address"}
                              name="address "
                              value={formData.address}
                              onChange={(e) => handleChange(e, "address")}
                            />
                          </Col>
                        </Row>
                      </Container>
                    </div>
                  </td>
                  <td className="mx-auto float-end">
                    <div>
                      <Calender
                        setLabel={(date) => setLabel(date, "bill_date")}
                        required={"*"}
                        initialDate={
                          formData.bill_date &&
                          moment(formData.bill_date).isValid()
                            ? moment(formData.bill_date).toDate()
                            : new Date()
                        }
                        calenderlabel="Bill Date"
                      />
                    </div>
                    <div>
                      <TextInputForm
                        placeholder={"EWAY Number"}
                        labelname={"EWAY Number"}
                        name="eway_no"
                        value={
                          type === "edit" ? formData.eway_no : formData.eway_no
                        }
                        onChange={(e) => handleChange(e, "eway_no")}
                      />
                    </div>
                    <div>
                      {" "}
                      <TextInputForm
                        placeholder={"VECHILE Number"}
                        labelname={"VECHILE Number"}
                        name="vechile_no"
                        value={
                          type === "edit"
                            ? formData.vechile_no
                            : formData.vechile_no
                        }
                        onChange={(e) => handleChange(e, "vechile_no")}
                      />{" "}
                    </div>
                    <div>
                      {" "}
                      <TextInputForm
                        placeholder={"State of Supply"}
                        labelname={"STATE OF SUPPLY"}
                        name="state_of_supply"
                        value={
                          type === "edit"
                            ? formData.state_of_supply
                            : formData.state_of_supply
                        }
                        onChange={(e) => handleChange(e, "state_of_supply")}
                      />{" "}
                    </div>
                  </td>
                </tr>
              </Table>
            </Col>
          </Row>
        </Container>
      </div>
      <div className="main my-3">
        <div>
          <Container fluid className="px-0">
            <Row>
              <Col lg="12" className="py-3">
                <div>
                  No Of Products : <span>{formData.product.length}</span>
                </div>
              </Col>
              <Col lg="12" md="6" xs="12">
                <div className="py-2 category-table bill">
                  <Table>
                    <thead className="">
                      <tr>
                        <th rowSpan={2}>#</th>
                        <th rowSpan={2} className="wrdbrk w-20">
                          Product Name
                        </th>
                        <th rowSpan={2} className="wrdbrk w-10">
                          Qty
                        </th>
                        <th rowSpan={2} className="wrdbrk w-10">
                          Unit
                        </th>
                        <th rowSpan={2} className="wrdbrk w-10">
                          Net Rate
                        </th>
                        <th rowSpan={2} className="wrdbrk w-10">
                          Total Net Amount
                        </th>
                        {/* <th rowSpan={2} className="wrdbrk w-10">
                          Discount Rate
                        </th>
                        <th rowSpan={2} className="wrdbrk w-10">
                          Total Discount Amount
                        </th>
                        <th rowSpan={2} className="wrdbrk w-10">
                          Product Wise Total Amount
                        </th> */}
                        <th rowSpan={2} className="wrdbrk w-10"></th>
                        <th rowSpan={2} className="wrdbrk w-10"></th>
                      </tr>
                    </thead>
                    <tbody>
                      {formData.product &&
                        formData.product.map((row, index) => (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>
                              <div>
                                <DropDownUI
                                  optionlist={productData.map((user) => ({
                                    value: user.product_id,
                                    label: `${user.product_code} - ${user.product_name}`,
                                  }))}
                                  placeholder="ProductName"
                                  filterOption={(option, input) => {
                                    const searchText = input.toLowerCase();
                                    const product = productData.find(
                                      (p) => p.product_id === option.value
                                    );
                                    return (
                                      product.product_code
                                        .toLowerCase()
                                        .includes(searchText) ||
                                      product.product_name
                                        .toLowerCase()
                                        .includes(searchText)
                                    );
                                  }}
                                  name="product_id"
                                  value={row.product_id}
                                  onChange={(updatedFormData) => {
                                    const selectedProduct = productData.find(
                                      (user) =>
                                        user.product_id ===
                                        updatedFormData.product_id
                                    );
                                    const taxLabel = selectedProduct
                                      ? `GST@${selectedProduct.item_gst}%`
                                      : "GST@0%";
                                    const qty =
                                      formData.product[index]?.qty || 1;
                                    const priceUnit = selectedProduct
                                      ? selectedProduct.unit_rate
                                      : 0;
                                    const discountRate = selectedProduct
                                      ? selectedProduct.unit_rate -
                                        (selectedProduct.unit_rate *
                                          selectedProduct.discount) /
                                          100
                                      : 0;
                                    setFormData({
                                      ...formData,
                                      product: formData.product.map((r, i) =>
                                        i === index
                                          ? {
                                              ...r,
                                              product_id:
                                                updatedFormData.product_id,
                                              price_unit: priceUnit.toFixed(2),
                                              discount_rate:
                                                discountRate.toFixed(2),
                                              tax_type: "GST",
                                              tax_percentage: selectedProduct
                                                ? selectedProduct.item_gst
                                                : 0,
                                              tax_label: taxLabel,
                                              unit: selectedProduct
                                                ? selectedProduct.unit_id
                                                : "",
                                              total_net_amount: (
                                                qty * priceUnit
                                              ).toFixed(2),
                                              total_discount_amount: (
                                                qty * discountRate
                                              ).toFixed(2),
                                            }
                                          : r
                                      ),
                                    });
                                  }}
                                  onKeyDown={(e) => handleKeyPress(e, index)}
                                  autoFocus={
                                    index === formData.product.length - 1
                                  }
                                />
                              </div>
                            </td>
                            <td>
                              <TextInputForm
                                placeholder={"qty"}
                                name="qty"
                                value={row.qty}
                                onChange={(e) => handleChange(e, "qty", index)}
                                onKeyDown={(e) => handleKeyPress(e, index)}
                              ></TextInputForm>
                            </td>
                            <td>
                              <DropDownUI
                                optionlist={UnitData.map((user) => ({
                                  value: user.unit_id,
                                  label: user.unit_name,
                                }))}
                                placeholder="Unit"
                                name="unit"
                                value={row.unit}
                                onChange={(updatedFormData) => {
                                  const selectedUnit = UnitData.find(
                                    (unit) =>
                                      unit.unit_id === updatedFormData.unit
                                  );
                                  setFormData({
                                    ...formData,
                                    product: formData.product.map((r, i) =>
                                      i === index
                                        ? {
                                            ...r,
                                            unit: updatedFormData.unit,
                                            unit_name: selectedUnit
                                              ? selectedUnit.unit_name
                                              : "", // Set unit_name
                                          }
                                        : r
                                    ),
                                  });
                                }}
                                onKeyDown={(e) => handleKeyPress(e, index)}
                              />
                            </td>
                            <td>
                              <TextInputForm
                                placeholder={"price"}
                                name="price"
                                value={row.price_unit}
                                onChange={(e) =>
                                  handleChange(e, "price_unit", index)
                                }
                                onKeyDown={(e) => handleKeyPress(e, index)}
                              />
                            </td>
                            <td>
                              <TextInputForm
                                placeholder={"total_net_amount"}
                                name="total_net_amount"
                                value={row.total_net_amount}
                                readOnly
                              />
                            </td>
                            {/* <td>
                              <TextInputForm
                                placeholder={"discount_rate"}
                                name="discount_rate"
                                value={row.discount_rate}
                                onChange={(e) =>
                                  handleChange(e, "discount_rate", index)
                                }
                                onKeyDown={(e) => handleKeyPress(e, index)}
                              />
                            </td>
                            <td>
                              <TextInputForm
                                placeholder={"total_discount_amount"}
                                name="total_discount_amount"
                                value={row.total_discount_amount}
                                readOnly
                              />
                            </td>

                            <td>
                              <TextInputForm
                                placeholder={"amt"}
                                name="total_amt"
                                value={row.total_amt}
                                onChange={(e) =>
                                  handleChange(e, "total_amt", index)
                                }
                                onKeyDown={(e) => handleKeyPress(e, index)}
                              />
                            </td> */}
                            <td>
                              {index === formData.product.length - 1 && (
                                <ClickButton
                                  label={<>Add</>}
                                  onClick={handleAddRow}
                                />
                              )}
                            </td>
                            <td>
                              <Delete
                                onClick={() => handleDeleteRow(index)}
                                label={<MdDeleteForever />}
                              ></Delete>
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </Table>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
        <div className="my-3">
          <Container>
            <Row>
              <Col lg="5"></Col>
              <Col lg="7">
                <div className="inside my-3">
                  <Table>
                    <tr></tr>
                    {/* <tr>
                      <td>Total Net Rate</td>
                      <td></td>
                      <td className="w-25">
                        <TextInputForm
                          placeholder={"Total Net Rate"}
                          name="total_net_rate"
                          value={formData.total_net_rate}
                          readOnly
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>Total Discount Rate</td>
                      <td></td>
                      <td className="w-25">
                        <TextInputForm
                          placeholder={"Total Discount Rate"}
                          name="total_discount_rate"
                          value={formData.total_discount_rate}
                          readOnly
                        />
                      </td>
                    </tr> */}
                    <tr>
                      <td>Sub Total</td>
                      <td></td>
                      <td className="w-25">
                        <TextInputForm
                          placeholder={"SubTotal"}
                          name="subtotal"
                          value={
                            type === "edit"
                              ? formData.subtotal
                              : formData.subtotal
                          }
                          onChange={handlePaidChange}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>Discount</td>
                      <td>
                        <DropDownUI
                          optionlist={discountOptions}
                          placeholder="Discount Type"
                          name="discount_type"
                          value={discountType}
                          onChange={(updatedValue) => {
                            setDiscountType(updatedValue.discount_type);
                            setFormData((prevData) => ({
                              ...prevData,
                              discount_type: updatedValue.discount_type,
                            }));
                            calculateTotal(formData.product);
                          }}
                        />
                      </td>
                      <td className="w-25">
                        <TextInputForm
                          placeholder={
                            discountType === "Discount %"
                              ? "Discount %"
                              : "Discount Amount"
                          }
                          name="discount"
                          value={formData.discount}
                          onChange={handleDiscountChange}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>Total</td>
                      <td></td>
                      <td className="w-25">
                        <TextInputForm
                          placeholder={"Total"}
                          name="total"
                          value={formData.total}
                          readOnly
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>Remark</td>
                      <td></td>
                      <td className="w-25">
                        <TextInputForm
                          placeholder="Remarks"
                          name="remark"
                          value={formData.remark}
                          onChange={(e) => {
                            handleRemarkChange(e, "remark");
                          }}
                          className="m-3"
                        />
                      </td>
                    </tr>
                  </Table>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
      <div className="main stick-bottom">
        <div className="w-50 ms-auto">
          <Container>
            <Row>
              <Col lg="12">
                <div className="text-center">
                  {type === "edit" ? (
                    <>
                      <ToastContainer
                        position="bottom-center"
                        autoClose={3000}
                        hideProgressBar={false}
                        newestOnTop={false}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                        theme="light"
                      />
                      <span className="mx-2">
                        <ClickButton
                          label={<>Update</>}
                          onClick={handleUpdateSubmit}
                        ></ClickButton>
                      </span>
                      <span className="mx-2">
                        <ClickButton
                          label={<>Cancel</>}
                          onClick={() => navigate("/console/sales/invoice")}
                        ></ClickButton>
                      </span>
                    </>
                  ) : (
                    <>
                      <ToastContainer
                        position="bottom-center"
                        autoClose={3000}
                        hideProgressBar={false}
                        newestOnTop={false}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                        theme="light"
                      />
                      <span className="mx-2">
                        <ClickButton
                          label={<>Submit</>}
                          onClick={handleSubmit}
                        ></ClickButton>
                      </span>
                      <span className="mx-2">
                        <ClickButton
                          label={<>Cancel</>}
                          onClick={() => navigate("/console/sales/invoice")}
                        ></ClickButton>
                      </span>
                    </>
                  )}
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    </>
  );
};
// saleinvoice end

export default SalesInvoiceEntry;
